import React, { useState, useEffect } from "react";
import DashboardHeader from "../../components/headers/DashboardHeader";
import { useNavigate } from "react-router-dom";

function FormStart() {
  const [activeStep, setActiveStep] = useState(1);
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    // Add other form fields for all steps here
  });
  const [completedSteps, setCompletedSteps] = useState([]);
  const [saveStatus, setSaveStatus] = useState("");
  const navigate = useNavigate();

  // Load saved data from localStorage on component mount
  useEffect(() => {
    const savedData = localStorage.getItem("formData");
    const savedSteps = localStorage.getItem("completedSteps");
    if (savedData) setFormData(JSON.parse(savedData));
    if (savedSteps) setCompletedSteps(JSON.parse(savedSteps));
  }, []);

  // Auto-save when formData or completedSteps change
  useEffect(() => {
    localStorage.setItem("formData", JSON.stringify(formData));
    localStorage.setItem("completedSteps", JSON.stringify(completedSteps));
  }, [formData, completedSteps]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const markStepComplete = (stepId) => {
    if (!completedSteps.includes(stepId)) {
      setCompletedSteps([...completedSteps, stepId]);
      setSaveStatus(`Step ${stepId} saved successfully!`);
      setTimeout(() => setSaveStatus(""), 3000);
    }
  };

  const steps = [
    { id: 1, name: "Travel & Legal History" },
    { id: 2, name: "Personal Identification" },
    { id: 3, name: "Contact Information" },
    { id: 4, name: "Visa & Processing Details" },
    { id: 5, name: "Supporting Documents" },
  ];

  const handleNext = () => {
    markStepComplete(activeStep);
    setActiveStep(activeStep + 1);
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };
  const handleSideBar = () => {
    navigate("/eligibility");
  };

  useEffect(() => {
    if (!localStorage.getItem("code-verified")) {
      navigate("/login", { replace: true });
    }
  }, []);

  return (
    <>
      <DashboardHeader />
      <div className="app-container">
        <div className="form-header">
          <h1>Complete Your Application Form</h1>
          <p className="instructions">
            Please fill out the following steps to complete your application.
            Your progress will be saved automatically as you complete each step.
          </p>
          {saveStatus && <div className="save-status">{saveStatus}</div>}
        </div>

        <div className="progress-steps">
          {steps.map((step) => (
            <div
              key={step.id}
              className={`step ${activeStep === step.id ? "active" : ""} ${
                completedSteps.includes(step.id) ? "completed" : ""
              }`}
              onClick={() => setActiveStep(step.id)}
            >
              <div className="step-number">{step.id}</div>
              <div className="step-name">{step.name}</div>
              {completedSteps.includes(step.id) && (
                <div className="step-checkmark">✓</div>
              )}
            </div>
          ))}
        </div>

        {/* Step 1: Travel & Legal History */}
        {activeStep === 1 && (
          <div className="form-container">
            {/* <h2>Travel & Legal History</h2>
            <div className="form-group">
              <label>Have you visited this country before?</label>
              <select name="visitedBefore" onChange={handleInputChange}>
                <option value="">Select option</option>
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </select>
            </div> */}
            {/* Add more fields for step 1 */}
          </div>
        )}

        {/* Step 2: Personal Identification */}
        {activeStep === 2 && (
          <div className="form-container">
            {/* <h2>Personal Identification</h2>
            <div className="form-group">
              <label>Passport Number:</label>
              <input
                type="text"
                name="passportNumber"
                onChange={handleInputChange}
              />
            </div> */}
            {/* Add more fields for step 2 */}
          </div>
        )}

        {/* Step 3: Contact Information */}
        {activeStep === 3 && (
          <div className="form-container">
            {/* <h2>Contact Information</h2>
            <div className="form-group">
              <label>Full Name:</label>
              <div className="input-options">
                <input
                  type="text"
                  name="fullName"
                  placeholder="Enter full name"
                  value={formData.fullName}
                  onChange={handleInputChange}
                />
                <input
                  type="text"
                  name="phone"
                  placeholder="Phone enter your full name"
                  value={formData.phone}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div className="form-group">
              <label>Email address:</label>
              <input
                type="email"
                name="email"
                placeholder="Enter email"
                value={formData.email}
                onChange={handleInputChange}
              />
              <p className="note">
                We will never share your email with anyone else
              </p>
            </div> */}
          </div>
        )}

        {/* Step 4: Visa & Processing Details */}
        {activeStep === 4 && (
          <div className="form-container">
            {/* <h2>Visa & Processing Details</h2>
            <div className="form-group">
              <label>Visa Type:</label>
              <select name="visaType" onChange={handleInputChange}>
                <option value="">Select visa type</option>
                <option value="tourist">Tourist</option>
                <option value="business">Business</option>
                <option value="student">Student</option>
              </select>
            </div> */}
            {/* Add more fields for step 4 */}
          </div>
        )}

        {/* Step 5: Supporting Documents */}
        {activeStep === 5 && (
          <div className="form-container">
            {/* <h2>Supporting Documents</h2>
            <div className="form-group">
              <label>Upload Passport Copy:</label>
              <input type="file" name="passportCopy" />
            </div> */}
            {/* Add more fields for step 5 */}
          </div>
        )}

        <div className="navigation">
          {/* {activeStep > 1 && (
            <button className="back-button" onClick={handleBack}>
              Back
            </button>
          )} */}
          {activeStep < steps.length ? (
            <button className="next-button" onClick={handleSideBar}>
              Continue
            </button>
          ) : (
            <button className="next-button" onClick={handleSideBar}>
              Continue
            </button>
          )}
          <button className="next-button" onClick={handleSideBar}>
            {" "}
            Delete
          </button>
        </div>
      </div>
    </>
  );
}

export default FormStart;
